// scripts for Capybara tests
import LocalTime from 'local-time';
// PDF.js is now loaded dynamically when needed
import { docReady } from 'src/docReady';
import { start as activeStorageStart } from '@rails/activestorage';
import Rails from '@rails/ujs';

import { mount as mountUnmoderated } from '@components/Unmoderated';
// Candidate - Public
import { mount as mountCandidateConsent } from 'components/Public/CandidateConsent/mount';
import { mount as mountConsentFormPage } from 'components/Public/ConsentFormPage/mount';
import { mount as mountSurvey } from 'components/Public/GQSurvey/mount';
import { mount as mountSchedulerApp } from 'components/Public/Scheduler/mount';
import { mount as mountPublicAssetApp } from 'components/PublicAssetApp/mount'; // guest users

import './system';
import 'src/sentry';
import 'src/datadog';
import 'stylesheets/application';
import 'react-loading-skeleton/dist/skeleton.css';
import 'src/formsort';
import 'controllers/public';
import 'react-datepicker/dist/react-datepicker.css';
import 'src/confirm';
import 'src/tooltips';
import 'src/timezone';
import 'src/tracking';
import 'setimmediate';

// Rails functionality
activeStorageStart();
window['Rails'] = Rails;

// PDF.js worker is configured dynamically when PDFView component loads

function onReady() {
  mountSurvey();
  mountCandidateConsent();
  mountConsentFormPage();
  mountSchedulerApp();
  mountUnmoderated();

  // TODO: Pull out into seperate guest pack!
  mountPublicAssetApp();
}
docReady(onReady);

LocalTime.start();

// ADD YOUR JAVACSRIPT HERE

// Start Rails UJS
Rails.start();
